import {useMemo} from 'react'
import {IssueCommentItem} from './IssueCommentItem'
import {ReviewSummaryItem} from './ReviewSummaryItem'
import type {ConversationItem} from './utils/build-conversation-items'
import {ThreadPreview} from './ThreadPreview'
import {HydrateThreadPositioning} from './HydrateThreadPositioning'

interface ConversationItemsProps {
  pullRequestAuthorLogin: string
  filteredConversationItems: ConversationItem[]
  onQuoteReply: (quotedText: string) => void
  onNavigateToDiffComment?: () => void
}

/** Renders conversation items - issue comments, review summaries, and threads. */
export function ConversationItems({
  filteredConversationItems,
  pullRequestAuthorLogin,
  onQuoteReply,
  onNavigateToDiffComment,
}: ConversationItemsProps) {
  const unassignedThreads = useMemo(
    () => filteredConversationItems.filter(item => item.type === 'thread').map(item => item.data),
    [filteredConversationItems],
  )

  return filteredConversationItems.length > 0 ? (
    <>
      <HydrateThreadPositioning threads={unassignedThreads} />
      <div className="d-flex flex-column position-relative width-full gap-3">
        {filteredConversationItems.map(item =>
          item.type === 'review-summary' ? (
            <ReviewSummaryItem
              key={item.key}
              reviewSummary={item.data.summary}
              reviewThreads={item.data.threads}
              pullRequestAuthorLogin={pullRequestAuthorLogin}
              onQuoteReply={onQuoteReply}
              withReviewStateIcon
              onNavigateToDiffComment={onNavigateToDiffComment}
            />
          ) : item.type === 'thread' ? (
            <ThreadPreview
              key={item.key}
              thread={item.data}
              selectedReviewId={null}
              onNavigateToDiffComment={onNavigateToDiffComment}
              headingLevel="h2"
            />
          ) : (
            <IssueCommentItem
              key={item.key}
              comment={item.data}
              pullRequestAuthorLogin={pullRequestAuthorLogin}
              onQuoteReply={onQuoteReply}
            />
          ),
        )}
      </div>
    </>
  ) : null
}
